import { createStore } from 'vuex'

export default createStore({
  state: {
    token: null,
    user: {
      guid: null,
      data: null
    }
  },
  getters: {
    TOKEN: state => {
      return state.token;
    },
    USER: state => {
      return state.user;
    }
  },
  mutations: {
    TOKEN: (state, data) => {
      state.token = data
    },
    USER_GUID: (state, data) => {
      state.user.guid = data
    },
    USER_DATA: (state, data) => {
      state.user.data = data
    }
  },
  actions: {
    TOKEN: (context, data) => {
      context.commit('TOKEN', data);
    },
    USER_GUID: (context, data) => {
      context.commit('USER_GUID', data);
    },
    USER_DATA: (context, data) => {
      context.commit('USER_DATA', data);
    }
  }
})
